export enum LayoutActionTypes {
  CHANGE_LAYOUT = 'CHANGE_LAYOUT',
  CHANGE_LAYOUT_MODE = 'CHANGE_LAYOUT_MODE',
  CHANGE_SIDEBAR_THEME = 'CHANGE_SIDEBAR_THEME',
  CHANGE_LAYOUT_WIDTH = 'CHANGE_LAYOUT_WIDTH',
  CHANGE_LAYOUT_POSITION = 'CHANGE_LAYOUT_POSITION',
  CHANGE_TOPBAR_THEME = 'CHANGE_TOPBAR_THEME',
  CHANGE_LEFTSIDEBAR_SIZE = 'CHANGE_LEFTSIDEBAR_SIZE',
  CHANGE_LEFTSIDEBAR_VIEW = 'CHANGE_LEFTSIDEBAR_VIEW',
  CHANGE_SIDEBAR_IMAGE = 'CHANGE_SIDEBAR_IMAGE',
  CHANGE_PRELOADER = 'CHANGE_PRELOADER',
  CHANGE_SIDEBAR_VISIBILITY = 'CHANGE_SIDEBAR_VISIBILITY',
  CHANGE_THEME_PRIMARY = 'CHANGE_THEME_PRIMARY',
  CHANGE_THEME_SECONDARY = 'CHANGE_THEME_SECONDARY',
  CHANGE_DARK_LOGO = 'CHANGE_DARK_LOGO',
  CHANGE_LIGHT_LOGO = 'CHANGE_LIGHT_LOGO',
  CHANGE_DARK_LOGO_SMALL = 'CHANGE_DARK_LOGO_SMALL',
  CHANGE_LIGHT_LOGO_SMALL = 'CHANGE_LIGHT_LOGO_SMALL',
  CHANGE_SETTHEME='CHANGE_SETTHEME',
  CHANGE_RESET = 'CHANGE_RESET'
}

interface ActionWithPayload<T, P> {
  type: T;
  payload: P;
}

export type LayoutActions =
  | ActionWithPayload<LayoutActionTypes.CHANGE_LAYOUT, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_LAYOUT_MODE, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_SIDEBAR_THEME, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_LAYOUT_WIDTH, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_LAYOUT_POSITION, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_TOPBAR_THEME, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_LEFTSIDEBAR_SIZE, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_LEFTSIDEBAR_VIEW, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_SIDEBAR_IMAGE, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_PRELOADER, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_SIDEBAR_VISIBILITY, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_THEME_PRIMARY, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_THEME_SECONDARY, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_LIGHT_LOGO, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_DARK_LOGO, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_LIGHT_LOGO_SMALL, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_DARK_LOGO_SMALL, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_RESET, string>
  | ActionWithPayload<LayoutActionTypes.CHANGE_SETTHEME, string>;

export interface LayoutState {
  layoutType: string,
  layoutModeType: string,
  leftSidebarType: string,
  layoutWidthType: string,
  layoutPositionType: string,
  topbarThemeType: string,
  leftsidbarSizeType: string,
  leftSidebarViewType: string
  leftSidebarImageType: string,
  preloader: string,
  sidebarVisibilitytype: string,
  themePrimary: string,
  themeSecondary: string,
  light_logo: string,
  dark_logo: string,
  light_logo_sm: string,
  dark_logo_sm: string
}